module.exports = __webpack_public_path__ + "794d1fa4b7b0b8553b3daebb8c75d2f9.png";